module.exports = __webpack_public_path__ + "static/media/boomtown.ec99962d.png";